import $ from 'jquery';

$(() => {
	if ($('.form').length > 0) $('.footer').addClass('footer--with-form');
});